// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItemModal-cls1___fe4f524f7b2da71917e{/*!*/}.CreateSocialItemModal-cls2___35ae5cf3c44db55b16e{margin:-10px;padding:10px;grid-gap:16px;gap:16px;overflow-y:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItemModal-cls1___fe4f524f7b2da71917e",
	"cls2": "CreateSocialItemModal-cls2___35ae5cf3c44db55b16e CreateSocialItemModal-cls1___fe4f524f7b2da71917e"
};
export default ___CSS_LOADER_EXPORT___;
